export default function decodeHtml(encodedText: string): string {
  const textArea = document.createElement('textarea')
  textArea.innerHTML = encodedText
  return textArea.value
}
